module.exports = __webpack_public_path__ + "static/img/404.9ed13bbe.svg";